var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon11S(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15418_33665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3335 14.2562C17.2576 17.6817 14.0574 20.1665 10.2768 20.1665C5.61368 20.1665 1.8335 16.3863 1.8335 11.7232C1.8335 7.94264 4.31826 4.7424 7.74378 3.6665",
    stroke: "#00605D",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0872 9.11849C19.1141 5.63251 16.3678 2.88625 12.8818 1.91316C11.3752 1.49259 10.0835 2.79984 10.0835 4.36406V10.5007C10.0835 11.2828 10.7175 11.9168 11.4996 11.9168H17.6363C19.2005 11.9168 20.5077 10.6251 20.0872 9.11849Z",
    stroke: "#00605D",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15418_33665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon11S);
export default __webpack_public_path__ + "static/media/icon11s.069658b8caec4b5b5995fd28c65f782a.svg";
export { ForwardRef as ReactComponent };